import { ChevronDown, AlertCircle } from "lucide-react";

export default function SelectField({
  id,
  label,
  value,
  onChange,
  options = [], // [{ value, label }]
  placeholder = "Select…",
  error,
  disabled = false,
  icon: Icon,
  testId,
}) {
  return (
    <div className="w-full min-w-0">
      {label && (
        <label
          htmlFor={id}
          className="mb-1.5 block text-[12px] font-semibold uppercase tracking-[0.14em] text-[hsl(220,30%,28%)]"
        >
          {label}
        </label>
      )}
      <div className="relative min-w-0">
        {Icon && (
          <Icon className="pointer-events-none absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-[hsl(220,15%,46%)]" strokeWidth={1.75} />
        )}
        <select
          id={id}
          value={value}
          onChange={onChange}
          disabled={disabled}
          data-testid={testId}
          className={`premium-select ${error ? "err" : ""} ${Icon ? "has-icon pl-12" : ""} ${disabled ? "opacity-60 cursor-not-allowed" : ""}`}
        >
          <option value="">{placeholder}</option>
          {options.map((o) => (
            <option key={o.value} value={o.value}>{o.label}</option>
          ))}
        </select>
        <ChevronDown className="pointer-events-none absolute right-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[hsl(220,15%,46%)]" />
      </div>
      {error && (
        <div className="mt-1.5 flex items-center gap-1.5 text-[12px] font-medium text-[hsl(356,78%,45%)]">
          <AlertCircle className="h-3.5 w-3.5" />
          <span>{error}</span>
        </div>
      )}
    </div>
  );
}
